  (function () {
    var GALLERY_SELECTORS = [
      '.media-gallery__viewer',
      '.product-info__media',
      '.product__media-wrapper',
      '.product__media-list',
      '.product-media-gallery',
      '.product-gallery',
      'media-gallery',
      '.product__media',
      '.slider-container',
      '.product-image-container',
      '.product-images',
      '.product__images'
    ];

    function isInHeaderOrNav(el) {
      return !!el.closest('header, nav, .site-header, .header, .shopify-section-header, .announcement-bar, footer');
    }

    function findGalleryBySelectors() {
      for (var i = 0; i < GALLERY_SELECTORS.length; i++) {
        var el = document.querySelector(GALLERY_SELECTORS[i]);
        if (el) return el;
      }
      return null;
    }

    function findGalleryByLargestImage() {
      var imgs = Array.prototype.slice.call(document.querySelectorAll('img'));
      var best = null;
      var bestArea = 0;
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (isInHeaderOrNav(img)) continue;
        var rect = img.getBoundingClientRect();
        if (rect.width < 200 || rect.height < 200) continue;
        var area = rect.width * rect.height;
        if (area > bestArea) { bestArea = area; best = img; }
      }
      if (!best) return null;
      var container = best.closest('figure, .slider-container, .product-image-container, [class*="gallery"], [class*="media"], [class*="image"]');
      return container || best.parentElement;
    }

    function placeWishlist() {
      var wishlist = document.querySelector('.xb-wishlist-button');
      if (!wishlist) return false;
      var gallery = findGalleryBySelectors() || findGalleryByLargestImage();
      if (!gallery) return false;

      var originalBlock = wishlist.closest('.product-info__block');
      if (originalBlock && !originalBlock.dataset.wishlistMoved) {
        originalBlock.style.display = 'none';
        originalBlock.dataset.wishlistMoved = 'true';
      }

      if (wishlist.parentElement && wishlist.parentElement.classList.contains('xb-wishlist-overlay')) {
        var currentHost = wishlist.parentElement.parentElement;
        if (currentHost === gallery) return true;
      }

      var computed = window.getComputedStyle(gallery);
      if (computed.position === 'static') gallery.style.position = 'relative';
      // iOS Safari resolves absolute children against an inline ancestor's line box,
      // not the visual rect — force block layout so right:12 lands as expected.
      if (computed.display === 'inline' || computed.display === 'inline-block') {
        gallery.style.display = 'block';
      }

      var wrapper = gallery.querySelector(':scope > .xb-wishlist-overlay');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'xb-wishlist-overlay';
        gallery.appendChild(wrapper);
      }
      wrapper.appendChild(wishlist);
      return true;
    }

    if (!placeWishlist()) {
      var observer = new MutationObserver(function () { placeWishlist(); });
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { observer.disconnect(); }, 10000);
    } else {
      var reassert = new MutationObserver(function () { placeWishlist(); });
      reassert.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { reassert.disconnect(); }, 4000);
    }
  })();
